import React from "react";



export const CodeInput =()=>{
    
    return(
        <div className="mb-3 ">
            <label htmlFor="inputEmail" className="form-label">code</label><br/>
           
                <input type="email" className="custom-input" id="inputEmil" required/>
               <div className="invalid-feedback">
                    Please enter a valid  code
                </div>
        </div>
    )
}